<div class="container container-student-applications mt-4">
  <div class="content-wrapper">

    <div class="row">

      <div class="col-12 col-sm-3 sidebar sidebar-left">

        <!-- navigation -->
        <div class="card">

          <div class="card-body">

            <ul class="nav nav-pills flex-column">
              <li class="nav-item">
                <a class="nav-link cursor-pointer" (click)="currentSection = 'applications'; getApplications()" [ngClass]="{'active': currentSection == 'applications'}">
                  {{'My applications' | translate}}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer" [ngClass]="{'active': currentSection == 'jobfavorites'}" (click)="currentSection = 'jobfavorites'">
                  {{'My saved jobs' | translate}}
                </a>
              </li>
              <li class="nav-item">
                <a class="nav-link cursor-pointer" (click)="currentSection = 'announcements'; getMyCallForOpportunities()" [ngClass]="{'active': currentSection == 'announcements'}">
                  {{'My announcements' | translate}}
                </a>
              </li>

            </ul>

            <button class="btn btn-danger btn-block" routerLink="/student/jobs">
              {{'Jobs' | translate}}
            </button>

          </div>

        </div>

      </div>

      <div class="col-12 col-sm-9 main-content">

        <div class="tab-content">

          <div id="tab-applications" [ngClass]="{'active': currentSection == 'applications'}" [class.d-none]="currentSection !== 'applications'" class="tab-pane">

            <div class="view">

              <div class="view-filter-toolbar-top">

                <div class="btn-toolbar">

                  <!-- limit filter -->
                  <div class="input-group mr-3">
                    <div clas="input-group-prepend">
                      <div class="input-group-text">{{'Show' | translate}}</div>
                    </div>
                    <select class="form-control" [(ngModel)]="view.limit">
                      <option *ngFor="let limit of view.limitOptions" [value]="limit.value">
                        {{limit.label}}
                      </option>
                    </select>
                  </div>

                  <!-- order by -->
                  <div class="input-group mr-3">
                    <div clas="input-group-prepend">
                      <div class="input-group-text">{{'Sort on' | translate}}</div>
                    </div>

                    <select class="form-control" [(ngModel)]="view.order">
                      <option *ngFor="let option of view.orderOptions" [value]="option.value">
                        {{option.label | translate}}
                      </option>
                    </select>
                  </div>

                  <!-- page filter -->
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <div class="input-group-text">{{'Page' | translate}}</div>
                    </div>
                    <select class="form-control" [(ngModel)]="view.page">
                      <option [value]="key + 1" *ngFor="let page of [].constructor(view.total_pages); let key = index;">
                        {{key + 1}}
                      </option>
                    </select>
                  </div>

                </div>

              </div>

              <!-- loader results -->
              <div *ngIf="view.isLoading">
                <app-loader></app-loader>
              </div>


              <!-- application result data -->
              <div class="results" *ngIf="view.data && !view.isLoading">

                <div class="card card-student-application mb-4" *ngFor="let application of view.data">
                  <div class="card-body">

                    <div class="row">

                      <div class="col-12 col-sm-2">
                        <div class="avatar">
                          <div class="circle">
                            <img class="image" *ngIf="application.jobPosting.trademark && application.jobPosting.trademark.avatarUri ? application.jobPosting.trademark.avatarUri : application.jobPosting.company.avatarUri" [src]="application.jobPosting.company.avatarUri" />
                          </div>
                        </div>

                      </div>

                      <div class="col-12 col-sm-6">

                        <h4 class="card-title mt-0">{{application.jobPosting.title}}</h4>
                        <p>{{'Company' | translate}}: {{(application.jobPosting.trademark && application.jobPosting.trademark.name ? application.jobPosting.trademark.name : application.jobPosting.company.name)}}</p>

                        <div class="date" *ngIf="application.createdOn">
                          <fa-icon [icon]="faCalendar"></fa-icon> {{application.createdOn | date:'dd-MM-YYYY'}}
                        </div>

                      </div>

                      <div class="col-12 col-sm-4">

                        <button class="btn btn-danger btn-block d-none">
                          <fa-icon [icon]="faTrash"></fa-icon> {{'Trash' | translate}}
                        </button>

                        <button class="btn btn-outline-secondary btn-block" (click)="openMotivationModal(application.motivationText)">
                          {{'My motivation' | translate}}
                        </button>

                        <button class="btn btn-outline-secondary btn-block" [routerLink]="'/jobs/' + application.jobPosting.id">
                          {{'View job' | translate}}
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <!-- no results -->
              <div class="results no-results alert alert-info" *ngIf="!view.isLoading && view.data.length == 0">
                <span class="">{{'No results' | translate}}</span>
              </div>


            </div>

          </div>

          <div id="tab-favorite-jobpostings" [ngClass]="{'active': currentSection == 'jobfavorites'}" [class.d-none]="currentSection !== 'jobfavorites'" class="tab-pane">

            <div class="view">

              <div class="results mt-4" *ngIf="viewFavorites.data.length > 0">

                <div class="grid grid-network grid-jobs equal-height">
                  <div class="row">
                    <div class="col-12 col-lg-4 col-md-4 col-sm-12" *ngFor="let job of viewFavorites.data">
                      <app-job-card (buttonEvent)="handleJobButtonEvent($event)" [roleType]="RoleTypes.Student" [data]="job"></app-job-card>
                    </div>
                  </div>
                </div>

              </div>

              <div *ngIf="viewFavorites.data.length === 0" class="results mt-4 no-results alert alert-info">
                <span>{{'No results' | translate}}</span>
              </div>

            </div>
          </div>

          <div id="tab-announcements" [ngClass]="{'active': currentSection == 'announcements'}" [class.d-none]="currentSection !== 'announcements'" class="tab-pane">

            <div class="view">

              <!-- loader results -->
              <div *ngIf="viewAnnouncements.isLoading">
                <app-loader></app-loader>
              </div>

              <!-- announcements result data -->
              <div class="results" *ngIf="viewAnnouncements.data && !viewAnnouncements.isLoading">

                <div class="card card-student-announcement mb-4" *ngFor="let announcement of viewAnnouncements.data">
                  <div class="card-body">

                    <div class="row">

                      <div class="col-12 col-sm-8">

                        <h4 class="card-title mt-0">{{'Looking for' | translate}}: {{announcement.lookingFor}}</h4>
                        <p class="card-text">{{announcement.personalDescription}}</p>

                        <div class="date" *ngIf="announcement.startDateTime">
                          <fa-icon [icon]="faCalendar"></fa-icon>
                          <span *ngIf="announcement.startDateTime && announcement.endDateTime">
                            {{announcement.startDateTime | date:'dd-MM-yyyy'}} - {{announcement.endDateTime | date:'dd-MM-yyyy'}}
                          </span>
                          <span *ngIf="announcement.startDateTime && !announcement.endDateTime">
                            {{'From' | translate}} {{announcement.startDateTime | date:'dd-MM-yyyy'}}
                          </span>
                        </div>

                      </div>

                      <div class="col-12 col-sm-4">

                        <button class="btn btn-danger btn-block" (click)="deleteCallForOpportunity(announcement.id)">
                          <fa-icon [icon]="faTrash"></fa-icon> {{'Delete' | translate}}
                        </button>

                      </div>

                    </div>

                  </div>

                </div>

              </div>

              <!-- no results -->
              <div class="results no-results alert alert-info" *ngIf="!viewAnnouncements.isLoading && viewAnnouncements.data.length == 0">
                <span class="">{{'No announcements found' | translate}}</span>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div>

  </div>

</div>
